import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.css"; // Bring in Bootstrap.
import App from "./App.js";

ReactDOM.render(
 
    <App />,

  document.getElementById("root")
);
